import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import SchemaTip from "./schema-tip.mdx";
import CustomEventIntro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`By default, PostHog automatically captures pageviews and pageleaves as well as clicks, change of inputs, and form submissions associated with `}<inlineCode parentName="p">{`a`}</inlineCode>{`, `}<inlineCode parentName="p">{`button`}</inlineCode>{`, `}<inlineCode parentName="p">{`form`}</inlineCode>{`, `}<inlineCode parentName="p">{`input`}</inlineCode>{`, `}<inlineCode parentName="p">{`select`}</inlineCode>{`, `}<inlineCode parentName="p">{`textarea`}</inlineCode>{`, and `}<inlineCode parentName="p">{`label`}</inlineCode>{` tags. See our `}<a parentName="p" {...{
        "href": "/docs/product-analytics/autocapture"
      }}>{`autocapture docs`}</a>{` for more details on this.`}</p>
    <p>{`If you prefer to disable or filter these, set the appropriate values in your `}<a parentName="p" {...{
        "href": "/docs/libraries/js/config"
      }}>{`configuration options`}</a>{`.`}</p>
    <h3 {...{
      "id": "custom-event-capture"
    }}>{`Custom event capture`}</h3>
    <CustomEventIntro mdxType="CustomEventIntro" />
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`posthog.capture('user_signed_up');
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SchemaTip mdxType="SchemaTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`posthog.capture('user_signed_up', {
    login_type: "email",
    is_free_trial: true
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      